export default "__VITE_ASSET__Vc3JNMZX__"